<template>
  <div class="main-wrapper">
    <ScreenAdapter>
      <div class="main">
        <!-- <div class="animatecar"></div> -->
        <div class="left-con">
          <TopHeader v-if="!drawer"></TopHeader>
          <Manage v-show="!drawer"></Manage>
          <div style="margin-top: 20px" v-show="!drawer">
            <Nurse></Nurse>
          </div>
          <div class="left-tit">
            <centertitle></centertitle>
          </div>
        </div>
        <div class="right-bg"></div>
        <div class="right-con">
          <div v-if="!serviceDrawer">
            <TemperatureHumidity></TemperatureHumidity>
          </div>
          <div v-show="!serviceDrawer"><Service></Service></div>
          <div v-show="!serviceDrawer"><Communication></Communication></div>
        </div>
        <div class="bottom-con">
          <div class="scroll-table-con">
            <ScrollTable></ScrollTable>
          </div>
          <div class="security-con">
            <Security></Security>
          </div>
        </div>
      </div>
      <el-drawer
        title="我是标题"
        :visible.sync="drawer"
        :with-header="false"
        append-to-body
        direction="ltr"
        size="26%"
        show-close
        wrapperClosable
      >
        <div class="left-drawer" :style="style" ref="leftDrawer">
          <manage-through v-show="currentMenu === 'manage'"></manage-through>
          <nurse-through v-if="currentMenu === 'nurse'"></nurse-through>
        </div>
      </el-drawer>
      <el-drawer
        title="我是标题"
        :visible.sync="serviceDrawer"
        :with-header="false"
        append-to-body
        direction="rtl"
        size="26%"
        show-close
        wrapperClosable
      >
        <div class="service-drawer" :style="style" ref="rightDrawer">
          <TemperatureHumidity
            v-if="currentMenu === 'service'"
          ></TemperatureHumidity>
          <ServiceDrawer v-if="currentMenu === 'service'"></ServiceDrawer>
          <SecurityThrough v-if="currentMenu === 'security'"></SecurityThrough>
          <CommunicationThrough
            v-if="currentMenu === 'communication'"
          ></CommunicationThrough>
          <centerhead v-if="currentMenu === 'headthrough'"></centerhead>
        </div>
      </el-drawer>
    </ScreenAdapter>

    <!-- websocket报警弹窗 -->
    <div class="alert-dialog-con" :style="alert_style" v-if="showAlert">
      <div class="play-icon">
        <a
          v-if="bjaudio"
          @click="playAudio()"
          style="cursor: pointer; float: right; margin-right: 10px"
          title="首次播报请手动点击播放"
          ><i class="el-icon-microphone"></i
        ></a>
      </div>
      <div class="title">{{ alertMessage.callTypeName }}</div>
      <div class="time">{{ alertMessage.createdDate }}</div>
      <div class="content">
        <div style="padding: 20px">
          {{ alertMessage.content }}
          <!-- <span
            >{{ alertMessage.buildingNo }}-{{ alertMessage.roomNo }}-{{
              alertMessage.bedNo
            }}
            {{ alertMessage.callTypeName }}，请尽快赶往现场查看处理！</span
          > -->
        </div>
        <div class="preview-video-con">
          <iframe
            width="100%"
            height="300px"
            frameborder="0"
            scrolling="auto"
            :src="ysurl"
          ></iframe>
        </div>
        <div class="btn-con">
          <div class="button" @click="upknow(alertMessage.id)">知道了</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TopHeader from "@/components/Top-Header/index"; // 顶部
import centertitle from "@/components/centertitle"; // 顶部四个数字
import Manage from "@/components/Manage/index"; // 智慧管理
import Nurse from "@/components/Nurse/index"; // 智慧照护
import ScrollTable from "@/components/Scroll-Table/index"; // 滚动表格
import Security from "@/components/Security/index";
import TemperatureHumidity from "@/components/TemperatureHumidity/index"; // 温湿度
import Service from "@/components/Service/index"; // 智慧服务
import ServiceDrawer from "@/components/ServiceDrawer/index"; // 智慧服务抽屉
import Communication from "@/components/Communication/index"; // 智慧交流
import { mapState, mapActions } from "vuex";
import { bigScreenIndex, bigScreenIndex2 } from "@/api/home";
import { getLastSixMon } from "@/utils/date";
import ScreenAdapter from "@/components/ScreenAdapter"; // 自适应组件
import Highcharts from "highcharts";
import ageChartOpts from "@/charts/home/age.js";
import vaccineChart from "@/charts/home/vaccine.js";
import detectionChart from "@/charts/home/detection.js";
import situationChart from "@/charts/home/situation.js"; // 接待情况面积图
import checkChart from "@/charts/home/check.js";
import manageThrough from "@/components/Manage/through"; // 智慧管理穿透
import nurseThrough from "@/components/Nurse/through"; // 智慧照护穿透
import SecurityThrough from "@/components/Security/through"; // 智慧安防穿透
import CommunicationThrough from "@/components/Communication/through"; // 智慧安防穿透
import centerhead from "@/components/centerhead/index"; // 头部四个数字穿透
import {
  getScreenUUid,
  listBao,
  getCall,
  getList,
  branchList,
} from "@/api/socket"; //获取Uuid,用于socket

export default {
  name: "Home",
  components: {
    TopHeader,
    centertitle,
    Manage,
    ScreenAdapter,
    Nurse,
    ScrollTable,
    Security,
    Service,
    TemperatureHumidity,
    ServiceDrawer,
    Communication,
    manageThrough,
    nurseThrough,
    SecurityThrough,
    CommunicationThrough,
    centerhead,
    // YearPicker,
    // systemInfo,
    // navBar,
  },
  computed: {
    ...mapState(["mapPoint", "currentMenu"]),
    drawer: {
      get() {
        return this.$store.state.drawer;
      },
      set(v) {
        this.$store.commit("setDrawer", v);
      },
    },
    // 点击智慧服务模块更多
    serviceDrawer: {
      get() {
        return this.$store.state.serviceDrawer;
      },
      set(v) {
        this.$store.commit("setServiceDrawer", v);
      },
    },
  },
  data() {
    return {
      // 侧边栏缩放
      style: {
        width: this.width + "px",
        height: this.height + "px",
        transform: "scale(1)",
      },
      alert_style: {
        transform: "scale(1) translateX(-50%)",
      },
      drawerBoolean: false,
      pollingST: null, // 轮询定时器
      timer: null,
      currentTime: "",
      monitorTime: "",
      data_1: [
        {
          title: "房间数（间）",
          value: 0,
        },
        {
          title: "总床位（床）",
          value: 2400,
        },
        {
          title: "入住人数",
          value: 1500,
        },
        {
          title: "入住率（%）",
          value: 62.5,
        },
      ],
      currentBuilding: 0,
      buildings: [
        {
          title: "1号楼",
          rooms: 600,
          beds: 1200,
          human: 300,
          rate: 25,
        },
        {
          title: "2号楼",
          rooms: 600,
          beds: 1200,
          human: 300,
          rate: 25,
        },
        {
          title: "3号楼",
          rooms: 600,
          beds: 1200,
          human: 300,
          rate: 25,
        },
        {
          title: "4号楼",
          rooms: 600,
          beds: 1200,
          human: 300,
          rate: 25,
        },
      ],
      currentSelectInfo: 1,
      baseInfo: [],
      staffInfo: [],
      menuArr: [
        {
          name: "园区概况",
          icon: require("../assets/home/yqgk@2x.png"),
          routeName: "Home",
        },
        {
          name: "院内服务",
          icon: require("../assets/home/ynfw@2x.png"),
          routeName: "Service",
        },
        {
          name: "安防监控",
          icon: require("../assets/home/afjk@2x.png"),
        },
        {
          name: "数据看板",
          icon: require("../assets/home/sjkb@2x.png"),
        },
      ],
      currentSituation: 0,
      situations: [
        {
          title: "预约参观",
        },
        {
          title: "预约入住",
        },
        {
          title: "访客管理",
        },
      ],
      selectyear: new Date().getFullYear(),
      tableData: [],
      age_data: [],
      nurse_data: [],
      gate_data: {}, // 智慧门岗
      sex_arr: [], // 颜色数据f
      check_data: {}, // 入/退住趋势
      visit_data: [], // 预约参观
      check_in_data: [], //预约入住
      fkts: [], // 访客管理
      ym_arr: [], //疫苗接种
      hs_arr: [
        {
          dataName: "员工检测次数",
          dataValue: 0,
        },
      ], //员工核酸数量
      websock: null,
      sessionKey: "",
      isHeartbeat: false,
      audio: new Audio(),
      bjaudio: "",
      timeoutnum: null,
      timeoutObj: null,
      serverTimeoutObj: null,
      timeout: 1000 * 20,
      warning_list: [], //报警
      showAlert: false, // 报警弹窗
      alertMessage: {}, //报警内容
      building: 0,
      branchList: [],
      ysurl:
        "https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/J07461723/1.hd.live&autoplay=1&accessToken=at.69hcrlj32cfynz4q8uxesmna0y8w2zmx-7p2neol6o8-1tpvwcy-4kkykaucd",
    };
  },
  async created() {},
  async mounted() {
    // let { data: res } = await branchList();
    // this.branchList = res;
    getList({ branchId: 6627 }).then(async (res) => {
      this.buildingList = res.data.data;
      this.building = res.data.data[16].id;
      this.getlistleft(this.building);
      let { data: uuidres } = await getScreenUUid({ branchId: 6627 });
      this.sessionKey = uuidres;
      setTimeout(() => {
        this.initWebSocket(this.sessionKey);
      }, 0);
    });

    this.setScale();
    window.onresize = this.Debounce(this.setScale, 1000);
    // this.getManage();
  },
  methods: {
    // 侧边栏缩放
    Debounce: (fn, t) => {
      const delay = t || 500;
      let timer;
      return function () {
        const args = arguments;
        if (timer) {
          clearTimeout(timer);
        }
        const context = this;
        timer = setTimeout(() => {
          timer = null;
          fn.apply(context, args);
        }, delay);
      };
    },
    // 获取放大缩小比例
    getScale() {
      const w = document.documentElement.clientWidth / this.width;
      const h = document.documentElement.clientHeight / this.height;
      // return w < h ? w : h;
      // const w = window.innerWidth / this.width;
      // const h = window.innerHeight / this.height;
      // return [w, h];
      return document.body.clientWidth / 1920;
    },
    // 设置比例
    setScale() {
      // this.style.transform =
      //   "scale(" +
      //   this.getScale()[0] +
      //   "," +
      //   this.getScale()[1] +
      //   ") translate(-50%, -50%)";
      this.style.transform = "scale(" + this.getScale() + ") ";
      this.alert_style.transform =
        "scale(" + this.getScale() + ") translateX(-50%)";
    },
    async initWebSocket(uuidres) {
      // let { data: uuidres } = await getScreenUUid({ branchId: 6627 });
      // this.sessionKey = uuidres;
      const protocol = location.protocol;
      let websocketProtocol;
      if (protocol.indexOf("https") === -1) {
        // 找不到https
        websocketProtocol = "ws";
      } else {
        websocketProtocol = "wss";
      }
      const url =
        `${websocketProtocol}://${location.host}/ophApi/websocket?param=guest` +
        uuidres;
      this.websock = new WebSocket(url);
      this.websock.onopen = this.websocketonopen;
      this.websock.onmessage = this.websocketonmessage;
      this.websock.onerror = this.websocketonerror;
      this.websock.onclose = this.websocketclose;
    },
    websocketonopen() {
      console.log("WebSocket连接成功");
      this.startOpenHeartbeat();
    },
    websocketonmessage(e) {
      console.log(JSON.parse(e.data), "消息");
      const reData = JSON.parse(e.data);
      console.log(99, reData);
      switch (reData.msgBody) {
        case "ping":
          break;
        default:
          if (reData.bizType == 1 || reData.bizType == 0) {
            this.getlistleft(reData.params.buildingId);
            console.log("请求报警列表", reData.params.buildingId);
            if (reData.bizType == 1) {
              this.bjaudio = reData.params.mp3Url;
              this.playAudio();
            }
          }
          break;
      }
      this.reset();
    },
    playAudio() {
      console.log("声音", this.audio);
      try {
        this.audio.pause();
        this.audio.currentTime = 0;
        this.audio.src = this.bjaudio;
        this.audio.load();
        this.audio.play();
      } catch (err) {
        console.log(err);
      }
    },
    //左侧报警列表
    getlistleft(buildingId) {
      // console.log(89, buildingId);
      var data = {
        buildingId: buildingId,
        status: 0,
      };
      listBao(data).then((res) => {
        this.warning_list = res.data.data.rows;
        if (this.warning_list != "") {
          this.showAlert = true;
          this.alertMessage = res.data.data.rows[0];
        } else if (res.data.data.rows.length == 0) {
          this.showAlert = false;
        }
      });
    },
    websocketonerror(e) {
      //连接建立失败重连
      console.log("连接失败", e);
      this.reconnect();
    },
    startOpenHeartbeat() {
      //开启心跳
      let self = this;
      self.timeoutObj && clearTimeout(self.timeoutObj);
      self.serverTimeoutObj && clearTimeout(self.serverTimeoutObj);
      self.timeoutObj = setTimeout(() => {
        console.log(self.websock.readyState, "状态");
        if (self.websock.readyState == 1) {
          var sendMsg = {
            sessionKey: "guest" + this.sessionKey,
            msgBody: "ping",
          };
          console.log("ping", sendMsg);
          self.websock.send(JSON.stringify(sendMsg));
        } else {
          self.reconnect();
        }
        self.serverTimeoutObj = setTimeout(function () {
          //超时关闭
          self.websock.close();
        }, self.timeout);
      }, self.timeout);
    },
    reset() {
      console.log("重置心跳");
      //重置心跳
      var that = this;
      //清除时间
      clearTimeout(that.timeoutObj);
      clearTimeout(that.serverTimeoutObj);
      //重启心跳
      that.startOpenHeartbeat();
    },
    reconnect() {
      //重新连接
      console.log("重新连接");
      var that = this;
      if (that.isHeartbeat) {
        return;
      }
      that.isHeartbeat = true;
      //没连接上会一直重连，设置延迟避免请求过多
      that.timeoutnum && clearTimeout(that.timeoutnum);
      that.timeoutnum = setTimeout(function () {
        //新连接
        that.initWebSocket(this.sessionKey);
        that.isHeartbeat = false;
      }, 5000);
    },
    upknow(id) {
      getCall({ id: id }).then((res) => {
        console.log(res);
      });
      this.showAlert = false;
    },
  },
  beforeDestroy() {
    if (!this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
    clearTimeout(this.pollingST);
  },
  destroyed() {
    clearTimeout(this.pollingST);
  },
};
</script>

<style lang="scss" scoped>
.main-wrapper {
  height: 100vh;
}
.alert-dialog-con {
  position: fixed;
  top: 15vh;
  left: 50%;
  transform: translateX(-50%);
  width: 700px;
  height: 605px;
  border: 1px solid #5fa0a0;
  box-shadow: inset 2px -1px 20px 8px #5fa0a0;
  z-index: 900;
  background: hsl(180deg 8% 21% / 40%);
  color: #fff;
  z-index: 30000;
  .play-icon {
    position: absolute;
    top: 40px;
    right: 10px;
    a {
      width: 30px;
      height: 30px;
    }
  }
  .title {
    width: 100%;
    margin-top: 40px;
    font-size: 24px;
    font-weight: bold;
    text-align: center;
    line-height: 30px;
  }
  .time {
    text-align: center;
    color: #d9d9d9;
    margin-top: 10px;
  }
  .content {
    margin-top: 40px;
    width: 70%;
    word-break: break-all;
    text-align: left;
    font-size: 20px;
    text-align: center;
    margin: 0 auto;
  }
  .btn-con {
    position: absolute;
    width: 100%;
    bottom: 40px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .button {
    width: 190px;
    height: 48px;
    line-height: 48px;
    text-align: center;
    color: #6ed3d3;
    border: 1px solid #6ed3d3;
    font-size: 16px;
    cursor: pointer;
  }
}
.main {
  // box-sizing: border-box;
  margin: 0 20px;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  position: relative;
  // background: url("../assets/home/index.png") no-repeat center;
  // background: url("../assets/index/bg.jpg") no-repeat center;
  background: url("../assets/index/bg-2.jpg") no-repeat center;
  background-size: contain;
  background-position: center top;
  z-index: 1;
  .preview-video-con {
    width: 80%;
    margin: 0 auto;
  }
  .animatecar {
    width: 40px;
    height: 40px;
    position: absolute;
    background: url("../assets/index/car.png") no-repeat center;
    background-size: 40px;
    /* 动画名字 */
    animation-name: move;
    /* 动画时间 */
    animation-duration: 20s;
    animation-delay: 5s;
    -webkit-animation-delay: 5s; /* Safari 和 Chrome */
    animation-timing-function: linear;
    animation-iteration-count: infinite;
    animation-direction: normal;
    @keyframes move {
      0% {
        // left: -650px;
        // bottom: -300px;
        // transform: rotate(22deg);
      }
      8% {
        left: 650px;
        bottom: -40px;
        transform: rotate(22deg);
      }
      16% {
        left: 780px;
        bottom: 80px;
        transform: rotate(36deg);
      }
      24% {
        left: 910px;
        bottom: 143px;
        transform: rotate(36deg);
      }
      32% {
        left: 1040px;
        bottom: 203px;
        transform: rotate(40deg);
      }
      40% {
        left: 1170px;
        bottom: 263px;
        transform: rotate(40deg);
      }
      48% {
        left: 1300px;
        bottom: 300px;
        transform: rotate(44deg);
      }
      56% {
        left: 1430x;
        bottom: 322px;
        transform: rotate(54deg);
      }
      64% {
        left: 1560px;
        bottom: 330px;
        transform: rotate(54deg);
      }
      72% {
        left: 1690px;
        bottom: 342px;
        transform: rotate(58deg);
      }
      80% {
        left: 1820px;
        bottom: 350px;
        transform: rotate(58deg);
      }
      90% {
        left: 1900px;
        bottom: 355px;
        transform: rotate(58deg);
      }
      100% {
        left: 2300px;
        bottom: 355px;
        transform: rotate(58deg);
      }
    }
  }
  // overflow: hidden;
  // ::v-deep .el-table {
  //   background: transparent !important;
  //   border: none !important;
  // }
  // ::v-deep .el-table th {
  //   background: transparent !important;
  //   border: none !important;
  // }
  // ::v-deep .el-table th,
  // ::v-deep .el-table tr,
  // ::v-deep .el-table td,
  // ::v-deep .el-table__body-wrapper {
  //   border: none !important;
  //   background-color: transparent;
  // }
  // ::v-deep .el-table::before {
  //   height: 0 !important;
  // }
  // ::v-deep .el-table .el-table__cell {
  //   padding: 6px 0 !important;
  // }
  // ::v-deep .el-table .header-class {
  //   color: #ffffff;
  //   background: rgba(88, 200, 154, 0.4) !important;
  //   height: 30px;
  // }
  // ::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td {
  //   background-color: rgba(0, 0, 0, 0) !important;
  // }
  .left-con {
    position: relative;
    box-sizing: border-box;
    padding: 0 20px;
    max-width: 1280px;
    width: 600px;
    height: 1080px;
    z-index: 1;
    // transform: rotate(0deg) scaleX(-1);
    opacity: 1;
    // left: 692px;
    // top: 0px;
    // background-image: linear-gradient(
    //   -90deg,
    //   rgba(19, 56, 65, 0) 0%,
    //   rgb(16, 45, 62) 100%
    // );
    opacity: 1;
    .left-tit {
      position: absolute;
      top: 87px;
      left: 0720px;
      width: 670px;
      height: 87px;
      border: 1px solid rgba(20, 255, 255, 0.61);
      background: rgba(0, 58, 140, 0.3);
    }
  }
  .bottom-con {
    position: absolute;
    right: 0;
    bottom: 10px;
    width: calc(100% - 450px);
    height: 213px;
    z-index: 2;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    .scroll-table-con {
      margin-left: 20px;
    }
    .security-con {
      margin-right: 30px;
    }
  }

  .right-con {
    position: absolute;
    top: 0;
    right: 0;
    box-sizing: border-box;
    padding: 0 20px;
    height: 1080px;
    z-index: 1;
    opacity: 1;
    // background-image: linear-gradient(
    //   90deg,
    //   rgba(19, 56, 65, 0) 0%,
    //   rgb(16, 45, 62) 100%
    // );
  }
}
::v-deep .el-drawer {
  background-color: rgba(19, 56, 65, 0);
}
.left-drawer {
  width: 100%;
  min-width: 450px;
  padding-left: 20px;
  padding-top: 20px;
  transform-origin: 0 0;
  transform-origin: left top;
  // position: absolute;
  // left: 50%;
  // top: 50%;
  transition: 0.3s;
}
.service-drawer {
  width: 100%;
  padding-left: 20px;
  // padding-top: 5px;
  padding-top: 20px;
  transform-origin: 0 0;
  // transform-origin: right top;
  transform-origin: left top;
  // position: absolute;
  // left: 50%;
  // top: 50%;
  transition: 0.3s;
}
</style>
<style>
.simple-row {
  color: #ffffff;
  height: 32px;
  text-align: center;
  background-color: transparent !important;
}
.blue-row {
  color: #ffffff;
  background: rgba(124, 181, 236, 0.3) !important;
  text-align: center;
  height: 32px;
}
</style>
